import * as React from 'react';
const { Fragment } = React;
const h = React.createElement;

export interface DescriptionsItemProps {
  label?: React.ReactNode;
  children?: React.ReactNode;
}

export interface DescriptionsProps {
  column?: number;
  size?: 'small' | 'default';
  bordered?: boolean;
  children?: React.ReactNode;
  className?: string;
}

interface DescriptionsComponent extends React.FC<DescriptionsProps> {
  Item: React.FC<DescriptionsItemProps>;
}

const DescriptionsBase: React.FC<DescriptionsProps> = function Descriptions(props) {
  const { column = 3, size = 'default', bordered = true, children, className = '' } = props;
  const cellPadding = size === 'small' ? 'px-3 py-1.5' : 'px-4 py-2.5';

  const items: DescriptionsItemProps[] = [];
  React.Children.forEach(children, (child) => {
    if (
      React.isValidElement(child) &&
      child.type === (Descriptions as unknown as DescriptionsComponent).Item
    ) {
      items.push(child.props as DescriptionsItemProps);
    }
  });

  const rows: DescriptionsItemProps[][] = [];
  for (let i = 0; i < items.length; i += column) {
    rows.push(items.slice(i, i + column));
  }

  return h(
    'div',
    {
      className: `overflow-hidden rounded-lg ${bordered ? 'border border-dark-700' : ''} ${className}`,
    },
    h(
      'table',
      { className: 'w-full text-sm' },
      h(
        'tbody',
        null,
        rows.map((row, ri) =>
          h(
            'tr',
            { key: ri, className: ri > 0 ? 'border-t border-dark-700' : '' },
            row.map((item, ci) =>
              h(
                Fragment,
                { key: ci },
                h(
                  'td',
                  {
                    className: `${cellPadding} text-dark-400 font-medium bg-dark-800/50 ${bordered ? 'border-r border-dark-700' : ''}`,
                    style: { width: `${100 / (column * 2)}%` },
                  },
                  item.label,
                ),
                h(
                  'td',
                  {
                    className: `${cellPadding} text-dark-200 ${ci < row.length - 1 && bordered ? 'border-r border-dark-700' : ''}`,
                  },
                  item.children,
                ),
              ),
            ),
            row.length < column &&
              Array.from({ length: (column - row.length) * 2 }).map((_, i) =>
                h('td', {
                  key: `empty-${i}`,
                  className: `${cellPadding} ${bordered ? 'border-r border-dark-700' : ''}`,
                }),
              ),
          ),
        ),
      ),
    ),
  );
};

const Descriptions = DescriptionsBase as DescriptionsComponent;

Descriptions.Item = function DescriptionItem(_props) {
  return null;
};

export { Descriptions };
